/* Adapter danych wykresu rytmow TOP20 — bez DOM i bez zaleznosci. */
(function () {
  'use strict';

  var ns = globalThis.PewniakiStatV2 || (globalThis.PewniakiStatV2 = {});

  function udzial(count, W) {
    return W > 0 ? count / W : null;
  }

  function slupek(wiersz, W, aktualny) {
    return {
      wzor: wiersz.wzor,
      count: wiersz.count,
      udzial: udzial(wiersz.count, W),
      aktualny: aktualny === wiersz.wzor
    };
  }

  ns.slupki = function (input) {
    var dane = input || {};
    var wiersze = Array.isArray(dane.wiersze) ? dane.wiersze.slice() : [];
    var W = typeof dane.W === 'number' ? dane.W : 0;
    var aktualny = typeof dane.aktualny === 'string' ? dane.aktualny : null;

    wiersze.sort(function (a, b) {
      if (b.count !== a.count) return b.count - a.count;
      return a.wzor < b.wzor ? -1 : (a.wzor > b.wzor ? 1 : 0);
    });

    var top = wiersze.slice(0, 20).map(function (w) {
      return slupek(w, W, aktualny);
    });

    // aktualny pokazujemy osobno tylko wtedy, gdy nie zmiescil sie w TOP20
    var pozaTop = null;
    if (aktualny !== null && !top.some(function (s) { return s.wzor === aktualny; })) {
      for (var i = 20; i < wiersze.length; i++) {
        if (wiersze[i].wzor === aktualny) {
          pozaTop = slupek(wiersze[i], W, aktualny);
          break;
        }
      }
    }

    return { slupki: top, pozaTop: pozaTop, razem: wiersze.length, W: W };
  };
})();
